{
  "ProjectBuilders": "Project Builders",
  "GroupBuilders": "Group Builders",
  "Tracks": "Tracks",
  "BuildersPublished": "Builders Published",
  "ExpandAll": "Expand All",
  "CollapseAll": "Collapse All",
  "BuilderPublishedTooltip": "Your answer to this builder is published to your project page. You’ve set the following visibility",
  "BuilderPublishedTooltip1": "Visit the builder to change visibility settings",
  "BuilderUnPublishedTooltip": "This builder has not been published yet. Any builders that have not been",
  "BuilderUnPublishedTooltip1": "published will not be included on your project page",
  "Published": "Published",
  "Progress": "Progress",
  "VisibilityOpt1": "Everyone",
  "VisibilityOpt2": "My Hubs, Groups, Events",
  "VisibilityOpt3": "My Events",
  "VisibilityOpt4": "Team Only",
  "PastDue": "Past Due",
  "Today": "Today",
  "DueToday": "Due Today",
  "Due": "Due",
  "NoDueDate": "No Due Date",
  "BackToAllBuilders": "Back to All Builders",
  "TrackCompletion": "Track Completion",
  "ViewGroupPage": "View Group Page",
  "BuilderSchedule": "Builder Schedule"
}
